import Styles from './DefaultPanel.module.scss'
import { RecentUploads } from 'components/ImagePickerModal/Uploads/RecentUploads'
import { useImagePickerContext } from 'components/ImagePickerModal/ImagePickerContext'
import { EditOption } from 'components/ArticlePostPreview/PostPreviewBody/EditOption/EditOption'
import { DefaultPanelProps } from './Types'
import { useRootStore } from 'stores/RootStore'
import { GenerateImageDrawer } from 'components/GenerateImageDrawer/GenerateImageDrawer'
import { useUploadsProject } from 'hooks/useUploadsProject'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useUploadAndInsert } from 'components/Design/MobileImageButtons/useUploadAndInsert'
import { useConfirm as useAiConfirm } from 'components/ImagePickerModal/AIGeneration/useConfirm'
import { GeneratedImage, SelectedImage } from 'types'

interface AiProps {
  onAiConfirm: (images: SelectedImage[]) => void
}

export const DefaultPanel = ({ insertToEditor, ...props }: DefaultPanelProps) => {
  const { confirm } = useAiConfirm()

  if (insertToEditor) return <DefaultPanelWithEditor {...props} />

  return <DefaultPanelContent {...props} onAiConfirm={confirm} />
}

export const DefaultPanelWithEditor = ({ ...props }: DefaultPanelProps) => {
  const { uploadAndInsert } = useUploadAndInsert()

  return <DefaultPanelContent {...props} onAiConfirm={(images) => uploadAndInsert(images[0] as GeneratedImage)} />
}

export const DefaultPanelContent = ({ hiddenProviders, setCurrentPanel, onAiConfirm }: DefaultPanelProps & AiProps) => {
  const { setProvider } = useImagePickerContext()
  const { drawersStore } = useRootStore()
  const workspaceId = useCurrentWorkspaceId()
  const uploadsProject = useUploadsProject(workspaceId)?.data?.project

  return (
    <div className={Styles.container}>
      <div className={Styles.mediaOptions}>
        {!hiddenProviders?.has('ai') && (
          <EditOption
            icon={
              <img
                className={Styles.imageIcon}
                src="https://res.cloudinary.com/almanac/image/upload/v1717354875/blaze_assets/Image%20Icons/ai_fxf1ts.png"
                alt="generate"
              />
            }
            name="Generate"
            onClick={() => {
              if (!uploadsProject) return

              drawersStore.openDrawer(GenerateImageDrawer, {
                onUse: (img) => {
                  onAiConfirm([img])
                },
              })
            }}
          />
        )}
        {!hiddenProviders?.has('uploads') && (
          <EditOption
            icon={
              <img
                className={Styles.imageIcon}
                src="https://res.cloudinary.com/almanac/image/upload/v1717162590/blaze_assets/Image%20Icons/mediaUpload_nqrffm.png"
                alt="upload"
              />
            }
            name="Upload"
            onClick={() => setCurrentPanel?.('uploadFromDevice')}
          />
        )}
        {!hiddenProviders?.has('link') && (
          <EditOption
            icon={
              <img
                className={Styles.imageIcon}
                src="https://res.cloudinary.com/almanac/image/upload/v1717162590/blaze_assets/Image%20Icons/addMediaLink_eudm5m.png"
                alt="Add Media Link"
              />
            }
            name="Add Media Link"
            onClick={() => setProvider('link')}
          />
        )}
      </div>
      <div className={Styles.mediaOptions}>
        {!hiddenProviders?.has('stock') && (
          <EditOption
            icon={
              <img
                className={Styles.imageIcon}
                src="https://res.cloudinary.com/almanac/image/upload/v1719567564/blaze_assets/Image%20Icons/stock_p2fw2u.png"
                alt="Stock"
              />
            }
            name="Stock Images"
            onClick={() => setProvider('stock')}
          />
        )}
        {!hiddenProviders?.has('gifs') && (
          <EditOption
            icon={
              <img
                className={Styles.imageIcon}
                src="https://res.cloudinary.com/almanac/image/upload/v1717162590/blaze_assets/Image%20Icons/giphy_uaigq4.png"
                alt="Giphy"
              />
            }
            name="GIFs"
            onClick={() => setProvider('gifs')}
          />
        )}
      </div>
      <RecentUploads onOpenAll={() => setProvider('uploads')} headingLevel={5} />
    </div>
  )
}
